import {
  Banner,
  H1Banner,
  HomeWrapper,
  Img,
  ImgWrapper,
  P,
  DownloadCurriculo,
  ButtonDownload,
} from "./Home.style";
import BgImg from "../../assets/home-bg-img/header-bg-img.jpg";

const Home = () => {
  return (
    <>
      <HomeWrapper id="home">
        <ImgWrapper>
          <Img src={BgImg} alt="Imagem de Fundo" />
        </ImgWrapper>
        <Banner>
          <H1Banner>Desenvolvedor Front-End</H1Banner>
          <P>João Paulo</P>
          <ButtonDownload>
            <DownloadCurriculo
              href="https://www.canva.com/design/DAFIYHZ1V3w/FYy2Xv-BZC2h3mUR4fOmfA/view?utm_content=DAFIYHZ1V3w&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton"
              download
              target="_blank"
            >
              Currículo
            </DownloadCurriculo>
          </ButtonDownload>
          :
        </Banner>
      </HomeWrapper>
    </>
  );
};

export default Home;
